import { instanceApi } from '../../services';

export const getIBPartnerHierarchyModel = (accountGuid: string): Promise<any> => instanceApi.get(`api/PartnersManagement/GetPartnerHierarchicalModel?accountGuidAuth=${accountGuid}`);

export const getIBPartnershipClientsAndAccounts = (partnershipId: number): Promise<any> => instanceApi.get(`api/PartnersManagement/GetPartnershipClientsHierarchicalModel?partnershipID=${partnershipId}`);

export const getFeatureFlagIsEnabled = (key: string): Promise<any> => instanceApi.get(`api/FeatureFlag/IsEnabled?key=${key}`);
